var React = require('react');

function IconThumbsDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.587 31.942a3.003 3.003 0 0 0 2.357-3.531l-.144-.713a14.899 14.899 0 0 0-1.8-4.7h9a3 3 0 0 0 1.381-5.662 3 3 0 0 0-1.312-5.281 3 3 0 0 0 .431-1.556 2.996 2.996 0 0 0-2.069-2.85 3 3 0 0 0-2.931-3.65h-6.094c-1.187 0-2.343.35-3.331 1.006L12.669 6.61A6 6 0 0 0 10 11.605V18.555c0 1.825.831 3.544 2.25 4.687l.463.369a8.979 8.979 0 0 1 3.2 5.262l.143.713a3.003 3.003 0 0 0 3.531 2.356ZM2 25.998h4c1.106 0 2-.893 2-2v-14c0-1.106-.894-2-2-2H2c-1.106 0-2 .894-2 2v14c0 1.107.894 2 2 2Z"}));
}

IconThumbsDown.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = IconThumbsDown;

IconThumbsDown.default = IconThumbsDown;
